import { CFPInputField, useCFPValues } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import { useDidMount } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Box, ComposableTypography } from '@bcp-nextgen-dx-component-factory/design-system';
import { Refresh } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { UIHelper } from '@helpers';
import { useTranslation } from '@hooks';
import { useFetchAccountGenerateCaptcha } from '@services';
import { useServicesStore } from '@store';

import { InvalidCaptchaAlert } from '../alerts';

const resources = {
	title: 'components.captcha.title',
	subtitle: 'components.captcha.subtitle',
	input: {
		label: 'components.captcha.input.label',
	},
};

export interface CaptchaProps {
	value?: string | null;
	onChange?: (value: string) => void;
}

export const Captcha = ({ value, onChange }: CaptchaProps) => {
	const { t } = useTranslation();
	const { getToken } = useCFPValues();
	const { fetch: fetchAccountGenerateCaptchaRequest } = useFetchAccountGenerateCaptcha();
	const { image } = useServicesStore((state) => state.accountGenerateCaptcha) || {};

	useDidMount(() => {
		fetchAccountGenerateCaptcha();
	});

	const fetchAccountGenerateCaptcha = async () => {
		try {
			await fetchAccountGenerateCaptchaRequest({});
		} catch {}
	};

	return (
		<Box styles={{ flexDirection: 'column', gap: UIHelper.rem(32) }}>
			<Box styles={{ flexDirection: 'column', gap: UIHelper.rem(8) }}>
				<ComposableTypography
					text={t(resources.title)}
					baseProps={{
						appearance: getToken({
							default: {
								default: 'subtitle-200-02',
							},
						}),
					}}
					tags={{}}
				/>

				<ComposableTypography
					text={t(resources.subtitle)}
					baseProps={{
						appearance: getToken({
							default: {
								default: 'body-100-02',
							},
						}),
						colorToken: 'secondary-light',
					}}
					tags={{}}
				/>
			</Box>

			{image && (
				<Box styles={{ alignItems: 'center' }}>
					<img
						src={`data:image/png;base64,${image}`}
						alt="captcha"
						style={{ flex: 1, maxHeight: UIHelper.rem(88) }}
					/>
					<div
						onClick={fetchAccountGenerateCaptcha}
						style={{
							marginLeft: UIHelper.rem(12),
							padding: UIHelper.rem(9),
							background: '#F5F6FA',
							borderRadius: '50%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							cursor: 'pointer',
						}}
					>
						<Refresh.Outline fill="#D1005D" size="small" />
					</div>
				</Box>
			)}

			<Box>
				<CFPInputField
					label={t(resources.input.label)}
					value={value || ''}
					onChange={(v) => onChange?.(v || '')}
				/>
				<div style={{ width: UIHelper.rem(60) }} />
			</Box>

			<InvalidCaptchaAlert />
		</Box>
	);
};
